const isArray = Array.isArray

export const putToArray = (array, indexes, element) => {
  if (indexes.length < 2 || !isArray(array)) return null

  if (!isArray(array[indexes[0]])) array[indexes[0]] = []

  if (2 == indexes.length) {
    array[indexes[0]][indexes[1]] = element
    return element
  }

  if (!isArray(array[indexes[0]][indexes[1]])) array[indexes[0]][indexes[1]] = []

  if (3 == indexes.length) {
    array[indexes[0]][indexes[1]][indexes[2]] = element
    return element
  }

  if (!isArray(array[indexes[0]][indexes[1]][indexes[2]])) array[indexes[0]][indexes[1]][indexes[2]] = []

  if (4 == indexes.length) {
    array[indexes[0]][indexes[1]][indexes[2]][indexes[3]] = element
    return element
  }

  if (!isArray(array[indexes[0]][indexes[1]][indexes[2]][indexes[3]]))
    array[indexes[0]][indexes[1]][indexes[2]][indexes[3]] = []

  array[indexes[0]][indexes[1]][indexes[2]][indexes[3]][indexes[4]] = element

  return element
}

export const getFromArray = (array, indexes) => {
  if (indexes.length < 2 || !isArray(array) || !isArray(array[indexes[0]])) return null

  if (2 == indexes.length) return array[indexes[0]][indexes[1]]

  if (!isArray(array[indexes[0]][indexes[1]])) return null

  if (3 == indexes.length) return array[indexes[0]][indexes[1]][indexes[2]]

  if (!isArray(array[indexes[0]][indexes[1]][indexes[2]])) return null

  if (4 == indexes.length) return array[indexes[0]][indexes[1]][indexes[2]][indexes[3]]

  if (!isArray(array[indexes[0]][indexes[1]][indexes[2]][indexes[3]])) return null

  if (5 == indexes.length) return array[indexes[0]][indexes[1]][indexes[2]][indexes[3]][indexes[4]]

  return null
}
